/**
 * mulberry32 over a state word stored in the save, so raids and Keystone rolls
 * are reproducible and reloading never rerolls an outcome.
 */

export interface RngHost {
  rng: number;
}

export function nextRandom(host: RngHost): number {
  host.rng = (host.rng + 0x6d2b79f5) | 0;
  let t = host.rng;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

export function randomRange(host: RngHost, min: number, max: number): number {
  return min + (max - min) * nextRandom(host);
}

export function pickWeighted<T extends string>(host: RngHost, weights: Readonly<Record<T, number>>): T {
  const entries = Object.entries(weights) as [T, number][];
  const total = entries.reduce((sum, [, w]) => sum + w, 0);
  let roll = nextRandom(host) * total;
  for (const [key, w] of entries) {
    roll -= w;
    if (roll <= 0) return key;
  }
  return entries[entries.length - 1]![0];
}

export function shuffled<T>(host: RngHost, items: readonly T[]): T[] {
  const out = [...items];
  for (let i = out.length - 1; i > 0; i -= 1) {
    const j = Math.floor(nextRandom(host) * (i + 1));
    [out[i], out[j]] = [out[j]!, out[i]!];
  }
  return out;
}
